var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnrollmentOverTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#fff;}.d{fill:#08a9f1;}.e{fill:#99e6fc;}.f{fill:#62dbfb;}.g{fill:#0071ce;}.h{fill:url(#b);opacity:.35;}.i{fill:#ebf0f3;}.j{fill:#c8effe;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 39.15,
    y1: 79.85,
    x2: 47.15,
    y2: 3.35,
    gradientTransform: "translate(0 86) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19ff55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007f0f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m0,32C0,20.8,0,15.2,2.18,10.92c1.92-3.76,4.98-6.82,8.74-8.74C15.2,0,20.8,0,32,0h22c11.2,0,16.8,0,21.08,2.18,3.76,1.92,6.82,4.98,8.74,8.74,2.18,4.28,2.18,9.88,2.18,21.08v22c0,11.2,0,16.8-2.18,21.08-1.92,3.76-4.98,6.82-8.74,8.74-4.28,2.18-9.88,2.18-21.08,2.18h-22c-11.2,0-16.8,0-21.08-2.18-3.76-1.92-6.82-4.98-8.74-8.74-2.18-4.28-2.18-9.88-2.18-21.08v-22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m57.53,70.19c-7.53,0-13.61-6.19-13.43-13.76.17-7.07,5.89-12.85,12.95-13.09,4.32-.15,8.19,1.74,10.75,4.78V9.71c0-.84-.68-1.52-1.52-1.52H21.02c-.84,0-1.52.68-1.52,1.52v43.6s-.2,21.5-.2,21.5c0,.99.79,1.8,1.78,1.8l16.63-.03h28.57c.84,0,1.52-.68,1.52-1.52v-9.66c-2.46,2.92-6.15,4.78-10.27,4.78h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m60.23,9.71v33.89c3.02.62,5.66,2.24,7.58,4.51V9.71c0-.84-.68-1.52-1.52-1.52h-7.58c.84,0,1.52.68,1.52,1.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m60.23,69.92v5.15c0,.84-.68,1.52-1.52,1.52h7.58c.84,0,1.52-.68,1.52-1.52v-9.66c-1.91,2.27-4.56,3.9-7.58,4.51h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m55.41,25.71c-.39,0-.77-.17-1.03-.46l-2.81-3.08c-.52-.57-.48-1.46.09-1.98.57-.52,1.46-.48,1.98.09l1.76,1.93,3.64-4.15c.51-.58,1.39-.64,1.97-.13.58.51.64,1.39.13,1.97l-4.67,5.32c-.26.3-.64.47-1.04.48,0,0,0,0-.01,0h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m55.41,39.34c-.39,0-.77-.17-1.03-.46l-2.81-3.08c-.52-.57-.48-1.46.09-1.98.57-.52,1.46-.48,1.98.09l1.76,1.93,3.64-4.15c.51-.58,1.39-.64,1.97-.13.58.51.64,1.39.13,1.97l-4.67,5.32c-.26.3-.64.47-1.04.48,0,0,0,0-.01,0h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m27.24,20.95h20.45c.77,0,1.4-.63,1.4-1.4s-.63-1.4-1.4-1.4h-20.45c-.77,0-1.4.63-1.4,1.4s.63,1.4,1.4,1.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m47.69,23.48h-20.45c-.77,0-1.4.63-1.4,1.4s.63,1.4,1.4,1.4h20.45c.77,0,1.4-.63,1.4-1.4s-.63-1.4-1.4-1.4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m47.69,31.79h-20.45c-.77,0-1.4.63-1.4,1.4s.63,1.4,1.4,1.4h20.45c.77,0,1.4-.63,1.4-1.4s-.63-1.4-1.4-1.4Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m47.69,37.11h-20.45c-.77,0-1.4.63-1.4,1.4s.63,1.4,1.4,1.4h20.45c.77,0,1.4-.63,1.4-1.4s-.63-1.4-1.4-1.4Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m39.08,45.43h-11.85c-.77,0-1.4.63-1.4,1.4s.63,1.4,1.4,1.4h11.85c.77,0,1.4-.63,1.4-1.4s-.63-1.4-1.4-1.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m39.08,50.75h-11.85c-.77,0-1.4.63-1.4,1.4s.63,1.4,1.4,1.4h11.85c.77,0,1.4-.63,1.4-1.4s-.63-1.4-1.4-1.4Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m39.08,57.24h-11.85c-.77,0-1.4.63-1.4,1.4s.63,1.4,1.4,1.4h11.85c.77,0,1.4-.63,1.4-1.4s-.63-1.4-1.4-1.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m39.08,62.56h-11.85c-.77,0-1.4.63-1.4,1.4s.63,1.4,1.4,1.4h11.85c.77,0,1.4-.63,1.4-1.4s-.63-1.4-1.4-1.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 57.53,
    cy: 56.75,
    r: 13.43
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m57.53,43.32c-1.17,0-2.31.15-3.4.43,5.77,1.51,10.03,6.75,10.03,13s-4.26,11.49-10.03,13c1.09.28,2.22.43,3.4.43,7.42,0,13.43-6.01,13.43-13.43s-6.01-13.43-13.43-13.43Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m57.53,71.59c-8.18,0-14.83-6.65-14.83-14.83s6.65-14.83,14.83-14.83,14.83,6.65,14.83,14.83-6.65,14.83-14.83,14.83Zm0-26.87c-6.64,0-12.03,5.4-12.03,12.03s5.4,12.03,12.03,12.03,12.03-5.4,12.03-12.03-5.4-12.03-12.03-12.03Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m64.86,58.15h-7.33c-.77,0-1.4-.63-1.4-1.4v-8.75c0-.77.63-1.4,1.4-1.4s1.4.63,1.4,1.4v7.35h5.93c.77,0,1.4.63,1.4,1.4s-.63,1.4-1.4,1.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollmentOverTime);
export default __webpack_public_path__ + "static/media/enrollment_over_time.660fc8c3f1df11dad9f684518769c295.svg";
export { ForwardRef as ReactComponent };